import { render } from "./KancolleSuffering.vue?vue&type=template&id=c983b9be"
import script from "./KancolleSuffering.vue?vue&type=script&lang=js"
export * from "./KancolleSuffering.vue?vue&type=script&lang=js"

import "./KancolleSuffering.vue?vue&type=style&index=0&id=c983b9be&scope=true&lang=css"
script.render = render

export default script